import React from "react";
import { Formik, Form } from "formik";
import CustomInput from "./CustomInput";
import Schema from "./Schema";
import CustomSelect from "./CustomSelect";
import CustomCheckbox from "./CustomCheckbox";

import Styles from "./SignupForm.module.css";
import PasswordCheck from '../signup/PasswordCheck';




function SignupForm() {

	return (
		<div className={Styles.sigupContainer}>
			<div className={Styles.formikContainer}>
				<h1 className={Styles.h1}>Signup</h1>
				
				<Formik
					initialValues={{
						username: "",
						email: "",
						password: "",
						confirmPassword: "",
						role: ["LocalGuide", "Tourist"],
						acceptedTos: false,
					}}
					
					validationSchema={Schema}
					onSubmit={(values, actions) => {
						setTimeout(() => {
							alert(JSON.stringify(values, null, 2));
							actions.setSubmitting(false);
						}, 1000);
						actions.resetForm();
					}}
				>
					{/* Since I'm using Field I don't have to pass
					onblur, onSubmit or values anymore it's automaticlly know it 
					a formik feild */}

					{({ isSubmitting }) => (
						<Form className={Styles.formContainer}>
							<CustomInput
								label='Username'
								name='username'
								type='text'
								placeholder='Enter your username'
							/>

							<CustomInput
								label='E-mail'
								name='email'
								type='email'
								placeholder='Enter your Email'
							/>

							<PasswordCheck
								label='Password'
								name='password'
								type='password'
								placeholder='Enter your password'
							/>

							<PasswordCheck
								label='Retype your password'
								name='confirmPassword'
								type='password'
								placeholder='Retype your password'
							/>

							<CustomSelect
								label='Are you a : '
								name='role'
								placeholder='Please select a job'
								options={[
									{
										label: "Local Guide",
										value: "LocalGuide",
									},
									{ label: "Tourist", value: "Tourist" },
								]}
							/>

							<CustomCheckbox
								type='checkbox'
								name='acceptedTos'
								message='I accept the terms and conditions'
							/>

							<button
								disabled={isSubmitting}
								type='submit'
								className={Styles.btn}
							>
								Signup
							</button>
						</Form>
					)}
				</Formik>
			</div>
		</div>
	);
}

export default SignupForm;
